import type { BarElementOwnerState, BarElementProps, BarElementSlotProps } from '@mui/x-charts/BarChart';
import { BarElement } from '@mui/x-charts/BarChart';
import { dayjs } from '@weft/utils';
import { get } from 'lodash';
import { useEffect } from 'react';

type RevenueChartBarElementProps = {
  dayInMonthRatio: number;
  deferredStartDate: Date;
  onClick: (barLength: number) => void;
  ownerState: BarElementOwnerState;
} & Omit<BarElementSlotProps['bar'], 'onClick'>;

export const RevenueChartBarElement: React.FC<RevenueChartBarElementProps> = ({ dayInMonthRatio, deferredStartDate, onClick, ownerState, ...restOfProps }) => {
  const currentBarLength = get(restOfProps, 'style.width.animation.to');
  
  useEffect(() => {
    if (typeof currentBarLength === 'number') {
      onClick(currentBarLength);
    }  
  }, [currentBarLength, onClick]);

  useEffect(() => {
    const onLoadBarLength = get(restOfProps, 'style.width.animation.to');

    if (typeof onLoadBarLength === 'number') {
      onClick(onLoadBarLength);
    }  
  }, []);

  const deferredMonthIndex = dayjs(deferredStartDate).month();
  const isFullyDeferred = deferredMonthIndex < ownerState.dataIndex;
  const isPartDeferred = deferredMonthIndex === ownerState.dataIndex;

  return (
    <>
      <BarElement
        {...restOfProps as BarElementProps}
        {...ownerState}
        color={isFullyDeferred ? '#ECEDEE' : ownerState.color}
      />
      {isPartDeferred && (
        <BarElement
          {...restOfProps as BarElementProps}
          {...ownerState}
          clipPath={`inset(0 0 0 ${dayInMonthRatio * 100}%)`}
          color='#ECEDEE'
        />
      )}
    </>
  );
};